// import React, { useState } from 'react';
import Globais from '../components/Globais/Globais';
import Axios from 'axios';
// import { codificaSenha, defineCodigoFrontend, defineCodigoOrdem, toBase64 } from '../services/funcoes.js';
// import { v4 as uuidv4 } from 'uuid';
// import { useUploadProgress } from '../contexts/UploadProgressProvider.js';
import { toast } from 'react-toastify';

// Filtro Dashboard - NAS
export const listarNas = async (clienteId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Analises";
  const campos = "distinct res_nasinicial as nas"
  const condicao = "cod_cliente = " + clienteId + " AND res_nasinicial is not null"
  const orderBy = "cast(res_nasinicial as unsigned integer)";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Filtro Dashboard - Anos
export const listarAnos = async (clienteId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_OrdManutencao";
  const campos = "distinct(year(dat_horinicial)) as ano"
  const condicao = "cod_cliente = " + clienteId 
  // + " AND a.cod_ordmanutencao = " + ordemId + " AND a.cod_equipamento = " + equipamentoId
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Dashboard
export const dashboard = async (filters) => {
  const url = Globais.url_consulta
  let tabela = "";
  let campos = "";
  let condicao = "";
  let groupBy = "";
  let orderBy = "";

  //graficoSumOfLitros
  tabela = "";
  campos = "(SELECT SUM(COALESCE(b.cap_compartimento, 0)) FROM Tab_Analises a, Tab_Compartimentos b "
    + "WHERE a.cod_cliente = " + filters.clienteId
    + " AND a.Res_NasInicial is not null"
    + " AND b.Cod_Cliente = a.Cod_Cliente"
    + " AND b.Cod_Equipamento = a.Cod_Equipamento"
    + " AND b.Cod_Compartimento = a.Cod_Compartimento"
    + ") as dialisado, "
    + "(SELECT SUM(COALESCE(b.cap_compartimento, 0)) from Tab_Compartimentos b "
    + "WHERE b.cod_cliente = " + filters.clienteId
    + ") as capacidade"
  condicao = ""; 
  groupBy = "";
  orderBy = "";

  const response1 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  console.log('graficoSumOfLitros: ', response1);

  //graficoQtdComDiaEquipamento
  tabela = "Tab_Equipamentos a, Tab_Compartimentos b";
  campos = "DISTINCT a.tag_equipamento as Eqp, COUNT(*) as Comp";
  condicao = "a.cod_cliente = " + filters.clienteId
    + " AND a.cod_cliente = b.cod_cliente"
    + " AND a.cod_equipamento = b.cod_equipamento";

  if (filters.equipamentoId) {
    condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

    if (filters.compartimentoId) condicao += " AND b.cod_compartimento = " + filters.compartimentoId;
  }

  if (filters.fluido) condicao += " AND b.tip_oleo = '" + filters.fluido + "'";

  if (filters.inicio || filters.ano || filters.mes || filters.nas) {
    condicao += " AND (SELECT COUNT(*) FROM Tab_Analises c WHERE c.cod_cliente = " + filters.clienteId;

    // if (filters.inicio && filters.fim) condicao += " AND c.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

    if (filters.ano) condicao += " AND YEAR(c.dat_horinicial) = " + filters.ano;

    if (filters.mes) condicao += " AND MONTH(c.dat_horinicial) = " + filters.mes;

    if (filters.nas) condicao += " AND c.res_nasinicial = " + filters.nas;

    condicao += ") > 0";
  }

  // console.log('Condicao: ', condicao);

  groupBy = "a.Tag_Equipamento";
  orderBy = "Comp desc";

  const response2 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('graficoQtdComDiaEquipamento: ', response2);

  //graficoVolDiaMes
  tabela = "Tab_Analises a, Tab_Compartimentos b";
  campos = "DISTINCT YEAR(a.dat_horinicial) as ano, MONTH(a.dat_horinicial) as mes, SUM(coalesce(b.cap_compartimento, 0)) as qtd";
  condicao = "a.cod_cliente = " + filters.clienteId;
  condicao += " AND a.cod_cliente = b.cod_cliente"
  condicao += " AND a.cod_equipamento = b.cod_equipamento"
  condicao += " AND a.cod_compartimento = b.cod_compartimento"

  if (filters.equipamentoId) {
    condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

    if (filters.compartimentoId) condicao += " AND a.cod_compartimento = " + filters.compartimentoId;
  }

  if (filters.fluido) condicao += " AND b.tip_oleo = '" + filters.fluido + "'";

  // if (filters.inicio && filters.fim) condicao += " AND a.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

  if (filters.ano) condicao += " AND YEAR(a.dat_horinicial) = " + filters.ano;

  if (filters.mes) condicao += " AND MONTH(a.dat_horinicial) = " + filters.mes;

  if (filters.nas) condicao += " AND a.res_nasinicial = " + filters.nas;

  groupBy = "YEAR(a.dat_horinicial), MONTH(a.dat_horinicial)";
  orderBy = "ano, mes";

  const response3 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('graficoVolDiaMes: ', response3);

  //graficoQtdCompartimento
  tabela = "Tab_Compartimentos a";
  campos = "DISTINCT a.tip_compartimento as comp, COUNT(*) as qtd";
  condicao = "a.cod_cliente = " + filters.clienteId;

  if (filters.equipamentoId) {
    condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

    if (filters.compartimentoId) condicao += " AND a.cod_compartimento = " + filters.compartimentoId;
  }

  if (filters.fluido) condicao += " AND a.tip_oleo = '" + filters.fluido + "'";

  if (filters.inicio || filters.ano || filters.mes || filters.nas) {
    condicao += " AND (SELECT COUNT(*) FROM Tab_Analises c WHERE c.cod_cliente = a.cod_cliente";
    condicao += " AND c.cod_equipamento = a.cod_equipamento";
    condicao += " AND c.cod_compartimento = a.cod_compartimento";

    if (filters.inicio && filters.fim) condicao += " AND c.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

    if (filters.ano) condicao += " AND YEAR(c.dat_horinicial) = " + filters.ano;

    if (filters.mes) condicao += " AND MONTH(c.dat_horinicial) = " + filters.mes;

    if (filters.nas) condicao += " AND c.res_nasinicial = " + filters.nas;

    condicao += ") > 0";
  }

  groupBy = "comp";
  orderBy = "qtd DESC,comp";

  // console.log('SQL QtdCompartimentos: ', campos, tabela, condicao);

  const response4 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('graficoQtdCompartimento: ', response4);

  //graficoVolComTipo
  tabela = "Tab_Compartimentos a";
  campos = "DISTINCT a.tip_compartimento as comp, COUNT(*) as qtd";
  condicao = "a.cod_cliente = " + filters.clienteId;

  if (filters.equipamentoId) {
    condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

    if (filters.compartimentoId) condicao += " AND a.cod_compartimento = " + filters.compartimentoId;
  }

  if (filters.fluido) condicao += " AND a.tip_oleo = '" + filters.fluido + "'";

  if (filters.inicio || filters.ano || filters.mes || filters.nas) {
    condicao += " AND (SELECT COUNT(*) FROM Tab_Analises c WHERE c.cod_cliente = a.cod_cliente";
    condicao += " AND c.cod_equipamento = a.cod_equipamento";
    condicao += " AND c.cod_compartimento = a.cod_compartimento";

    if (filters.inicio && filters.fim) condicao += " AND c.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

    if (filters.ano) condicao += " AND YEAR(c.dat_horinicial) = " + filters.ano;

    if (filters.mes) condicao += " AND MONTH(c.dat_horinicial) = " + filters.mes;

    if (filters.nas) condicao += " AND c.res_nasinicial = " + filters.nas;

    condicao += ") > 0";
  }

  groupBy = "comp";
  orderBy = "qtd DESC,comp";

  const response5 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('graficoVolDiaAnoMes: ', response5);

  //graficoNASInicialFinal
  tabela = "Tab_OrdManutencao a, Tab_Analises b, Tab_Compartimentos c, Tab_Equipamentos d";

  campos = "DISTINCT d.tag_equipamento as tag, c.tip_compartimento as comp, YEAR(COALESCE(a.Dat_HorInicial, '2000-01-01')) AS ano, "
    + "MAX(COALESCE(b.res_nasinicial, 0)) as inicial, MIN(COALESCE(b.res_nasfinal, 0)) as final";

  condicao = "a.cod_cliente = " + filters.clienteId;
  
  if (filters.equipamentoId) condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

  condicao += " AND b.cod_cliente = a.cod_cliente"
  condicao += " AND b.cod_ordmanutencao = a.cod_ordmanutencao"
  condicao += " AND b.cod_equipamento = a.cod_equipamento"

  if (filters.compartimentoId) condicao += " AND b.cod_compartimento = " + filters.compartimentoId;

  condicao += " AND c.cod_cliente = b.cod_cliente"
  condicao += " AND c.cod_equipamento = b.cod_equipamento"
  condicao += " AND c.cod_compartimento = b.cod_compartimento"

  if (filters.fluido) condicao += " AND c.tip_oleo = '" + filters.fluido + "'";

  condicao += " AND d.cod_cliente = c.cod_cliente"
  condicao += " AND d.cod_equipamento = c.cod_equipamento"

  if (filters.inicio && filters.fim) condicao += " AND b.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

  if (filters.ano) condicao += " AND YEAR(a.dat_horinicial) = " + filters.ano;

  if (filters.mes) condicao += " AND MONTH(a.dat_horinicial) = " + filters.mes;

  if (filters.nas) condicao += " AND b.res_nasinicial = " + filters.nas;

  groupBy = "d.tag_equipamento, c.tip_compartimento, YEAR(COALESCE(a.Dat_HorInicial, '2000-01-01'))";
  orderBy = "d.tag_equipamento, c.tip_compartimento, YEAR(COALESCE(a.Dat_HorInicial, '2000-01-01'))";

  // console.log('SQL NAS: ', campos, tabela, condicao, groupBy, orderBy);

  const response6 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('graficoNASInicialFinal: ', response6);

  //tabelaDesvios
  tabela = "Tab_OrdManutencao a LEFT JOIN Tab_Analises b ON a.Cod_Cliente = b.Cod_Cliente"
    + " AND a.Cod_OrdManutencao = b.Cod_OrdManutencao AND b.Res_NasInicial is null"
    + " LEFT JOIN Tab_Compartimentos c ON c.Cod_Cliente = b.Cod_Cliente"
    + " AND c.Cod_Equipamento = b.Cod_Equipamento AND c.Cod_Compartimento = b.Cod_Compartimento"
    + " LEFT JOIN Tab_Equipamentos d ON d.cod_cliente = c.cod_cliente AND d.cod_equipamento = c.cod_equipamento"
    + " LEFT JOIN Tab_Desvios e ON e.cod_cliente = a.cod_cliente AND a.cod_desvio = e.cod_desvio";

  campos = "e.Des_Desvio as desvio, d.tag_equipamento as eqp, c.tip_compartimento as comp, a.obs_ordmanutencao as obs";

  condicao = "a.cod_cliente = " + filters.clienteId;
  condicao += " AND a.cod_desvio IS NOT NULL";

  if (filters.equipamentoId) {
    condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

    if (filters.compartimentoId) condicao += " AND b.cod_compartimento = " + filters.compartimentoId;
  }

  if (filters.fluido) condicao += " AND c.tip_oleo = '" + filters.fluido + "'";

  // if (filters.inicio && filters.fim) condicao += " AND a.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

  if (filters.ano) condicao += " AND YEAR(a.dat_horinicial) = " + filters.ano;

  if (filters.mes) condicao += " AND MONTH(a.dat_horinicial) = " + filters.mes;

  // if (filters.nas) condicao += " AND a.res_nasinicial = " + filters.nas;

  groupBy = "";
  orderBy = "desvio, eqp, comp";

  // console.log('Tabela Desvios: ', campos, tabela, condicao, groupBy, orderBy);

  const response7 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('Response Tabela Desvio: ', response7);

  // graficoQtdDesvio
  tabela = "Tab_OrdManutencao a";
  tabela += " LEFT JOIN Tab_Analises b ON b.cod_cliente = a.cod_cliente";
  tabela += " AND b.cod_ordmanutencao = a.cod_ordmanutencao";
  tabela += " LEFT JOIN Tab_Compartimentos c ON c.cod_cliente = b.cod_cliente";
  tabela += " AND c.cod_equipamento = b.cod_equipamento";
  tabela += " AND c.cod_compartimento = b.cod_compartimento, Tab_Desvios d";

  campos = "DISTINCT d.des_desvio as desvio, COUNT(*) as qtd";

  condicao = "a.cod_cliente = " + filters.clienteId;
  condicao += " AND d.cod_cliente = a.cod_cliente";
  condicao += " AND d.cod_desvio = a.cod_desvio";

  if (filters.equipamentoId) {
    condicao += " AND a.cod_equipamento = " + filters.equipamentoId;

    if (filters.compartimentoId) condicao += " AND b.cod_compartimento = " + filters.compartimentoId;
  }

  if (filters.fluido) condicao += " AND c.tip_oleo = '" + filters.fluido + "'";

  // if (filters.inicio && filters.fim) condicao += " AND a.dat_horinicial BETWEEN '" + filters.inicio + "' AND '" + filters.fim + "'";

  if (filters.ano) condicao += " AND YEAR(a.dat_horinicial) = " + filters.ano;

  if (filters.mes) condicao += " AND MONTH(a.dat_horinicial) = " + filters.mes;

  if (filters.nas) condicao += " AND b.res_nasinicial = " + filters.nas;

  groupBy = "d.des_desvio";
  orderBy = "COUNT(*) desc";

  const response8 = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    groupBy: groupBy,
    orderBy: orderBy
  });

  // console.log('graficoQtdDesvio: ', response8);

    return ({
      graficoSumOfLitros: JSON.parse(response1.data.body),
      graficoQtdComDiaEquipamento: JSON.parse(response2.data.body),
      graficoVolDiaMes: JSON.parse(response3.data.body),
      graficoQtdComTipo: JSON.parse(response4.data.body),
      graficoVolComTipo: JSON.parse(response5.data.body),
      graficoNASInicialFinal: JSON.parse(response6.data.body),
      tabelaDesvios: JSON.parse(response7.data.body),
      graficoQtdDesvio: JSON.parse(response8.data.body)
    });
}


